import changeSelectedFileProvider from '../actions/changeSelectedFileProvider';
import getAddedProviders from '../utils/getAddedProviders';
import getDefaultFileProvider from '../actions/helpers/getDefaultFileProvider';
import { AttachmentDataProviderType } from '..';
import { fileProviderRemoved } from 'owa-fileprovider-store';
import { getFilePickerStore } from '../store/filePickerStore';
import { orchestrator } from 'satcheljs';

orchestrator(fileProviderRemoved, actionMessage => {
    fileProviderRemovedOrchestrator(actionMessage.providerType);
});

export default async function fileProviderRemovedOrchestrator(
    providerType: AttachmentDataProviderType
) {
    const viewState = getFilePickerStore().viewState;

    if (viewState.selectedFileProvider && viewState.selectedFileProvider.type === providerType) {
        // Change to the default provider if the selected provider was removed
        const defaultProvider = getDefaultFileProvider(getAddedProviders());
        changeSelectedFileProvider(defaultProvider, viewState);
    }
}
